module.exports = __webpack_public_path__ + "img/_img_arrow_right.ea84ff6b.svg";